export const logosDataDe = {
    customer: [
        {
            imgSource: 'customer/baumit.svg',
            imgAlt: 'Baumit GmbH',
            imgLink: 'https://baumit.at/'
        },
        {
            imgSource: 'customer/calzedonia.svg',
            imgAlt: 'Calzedonia',
            imgLink: 'https://www.calzedonia.com/'
        },
        {
            imgSource: 'customer/DEKRA_Arbeit_Gruppe.jpg',
            imgAlt: 'DEKRA Arbeit GmbH',
            imgLink: 'https://www.dekra-arbeit.at/'
        },
        {
            imgSource: 'customer/doco.svg',
            imgAlt: 'DO & CO',
            imgLink: 'http://www.doco.com/de'
        },
        {
            imgSource: 'customer/ikea.svg',
            imgAlt: 'IKEA',
            imgLink: 'https://www.ikea.com/'
        },
        {
            imgSource: 'customer/manpower.svg',
            imgAlt: 'Manpower',
            imgLink: 'https://www.manpower.at/'
        },
        {
            imgSource: 'customer/mediamarkt.svg',
            imgAlt: 'Media Markt',
            imgLink: 'https://www.mediamarkt.at/'
        },
        {
            imgSource: 'customer/metro.svg',
            imgAlt: 'Metro',
            imgLink: 'https://www.metro.at/'
        },
        {
            imgSource: 'customer/mth-retail.jpg',
            imgAlt: 'MTH Retail Group',
            imgLink: 'https://www.mth-retailgroup.com/'
        },
        {
            imgSource: 'customer/obi.svg',
            imgAlt: 'OBI',
            imgLink: 'https://www.obi.at/'
        },
        {
            imgSource: 'customer/porsche-interauto.svg',
            imgAlt: 'Porsche Inter Auto',
            imgLink: 'https://www.porscheinterauto.at/'
        },
        {
            imgSource: 'customer/randstad.svg',
            imgAlt: 'Randstad Holding',
            imgLink: 'https://www.randstad.at/'
        },
        {
            imgSource: 'customer/sodexo.svg',
            imgAlt: 'Sodexo',
            imgLink: 'https://www.sodexo.at/'
        },
        {
            imgSource: 'customer/trenkwalder.svg',
            imgAlt: 'Trenkwalder Personaldienste GmbH',
            imgLink: 'https://at.trenkwalder.com/'
        }
    ],
    marketing: [
        {
            imgSource: 'marketing-at/atv.svg',
            imgAlt: 'ATV',
            imgLink: 'https://www.atv.at/'
        },
        {
            imgSource: 'marketing-at/derstandard.svg',
            imgAlt: 'Der Standard',
            imgLink: 'https://derstandard.at/'
        },
        {
            imgSource: 'marketing-at/die-presse.svg',
            imgAlt: 'Die Presse',
            imgLink: 'https://www.diepresse.com/'
        },
        {
            imgSource: 'marketing-at/facebook.svg',
            imgAlt: 'Facebook',
            imgLink: 'https://www.facebook.com/'
        },
        {
            imgSource: 'marketing-at/fm4.svg',
            imgAlt: 'FM4',
            imgLink: 'https://fm4.orf.at/'
        },
        {
            imgSource: 'marketing-at/google.svg',
            imgAlt: 'Google',
            imgLink: 'https://www.google.com/'
        },
        {
            imgSource: 'marketing-at/hitradio-oe3.svg',
            imgAlt: 'Hitradio Ö3',
            imgLink: 'https://oe3.orf.at/'
        },
        {
            imgSource: 'marketing-at/instagram.svg',
            imgAlt: 'Instagram',
            imgLink: 'https://www.instagram.com/'
        },
        {
            imgSource: 'marketing-at/kronehit.svg',
            imgAlt: 'kronehit',
            imgLink: 'https://www.kronehit.at/'
        },
        {
            imgSource: 'marketing-at/orf.svg',
            imgAlt: 'ORF',
            imgLink: 'https://orf.at/'
        },
        {
            imgSource: 'marketing-at/prosieben-austria.svg',
            imgAlt: 'ProSieben Austria',
            imgLink: 'https://www.prosieben.at/'
        },
        {
            imgSource: 'marketing-at/puls4.svg',
            imgAlt: 'Puls 4',
            imgLink: 'https://www.puls4.com/'
        },
        {
            imgSource: 'marketing-at/servus-tv.svg',
            imgAlt: 'Servus TV',
            imgLink: 'https://www.servustv.com/'
        },
        {
            imgSource: 'marketing-at/youtube.svg',
            imgAlt: 'Youtube',
            imgLink: 'https://www.youtube.com/'
        },
        {
            imgSource: 'marketing-de/bild-de.svg',
            imgAlt: 'Bild',
            imgLink: 'https://www.bild.de/'
        },
        {
            imgSource: 'marketing-de/business-insider.svg',
            imgAlt: 'Business Insider',
            imgLink: 'https://www.businessinsider.de/'
        },
        {
            imgSource: 'marketing-de/faz.svg',
            imgAlt: 'Frankfurter Allgemeine Zeitung',
            imgLink: 'https://www.faz.net/'
        },
        {
            imgSource: 'marketing-de/gq.svg',
            imgAlt: 'GQ Magazine',
            imgLink: 'https://www.gq-magazin.de/'
        },
        {
            imgSource: 'marketing-de/hamburger-mopo.svg',
            imgAlt: 'Hamburger Morgenpost',
            imgLink: 'https://www.mopo.de/'
        },
        {
            imgSource: 'marketing-de/hrm.svg',
            imgAlt: 'Human Resources Manager',
            imgLink: 'https://www.humanresourcesmanager.de/'
        },
        {
            imgSource: 'marketing-de/sat1.svg',
            imgAlt: 'Sat.1',
            imgLink: 'https://www.sat1.de/'
        },
        {
            imgSource: 'marketing-de/spotify.svg',
            imgAlt: 'Spotify',
            imgLink: 'https://www.spotify.com/'
        },
        {
            imgSource: 'marketing-de/stroeer.svg',
            imgAlt: 'Ströer (Ströer Media)',
            imgLink: 'https://www.stroeer.com/'
        },
        {
            imgSource: 'marketing-de/galileo.svg',
            imgAlt: 'Galileo',
            imgLink: 'https://www.prosieben.de/serien/galileo'
        }
    ],
    partner: [
        {
            imgSource: 'partner-at/e-recruiter.svg',
            imgAlt: 'eRecruiter GmbH',
            imgLink: 'https://www.erecruiter.net/'
        },
        {
            imgSource: 'partner-at/ey.svg',
            imgAlt: 'Ernst & Young',
            imgLink: 'https://www.ey.com/de_at'
        },
        {
            imgSource: 'partner-at/ffg.svg',
            imgAlt: 'Austrian Research Promotion Agency',
            imgLink: 'https://www.ffg.at/'
        },
        {
            imgSource: 'partner-at/hogapage.svg',
            imgAlt: 'HOGAPAGE Media GmbH',
            imgLink: 'https://www.hogapage.at/'
        },
        {
            imgSource: 'partner-at/karriereat.svg',
            imgAlt: 'karriere.at',
            imgLink: 'https://www.karriere.at/'
        },
        {
            imgSource: 'partner-at/pwc.svg',
            imgAlt: 'PwC Österreich',
            imgLink: 'https://www.pwc.at/'
        },
        {
            imgSource: 'partner-de/stellenanzeigen-de.svg',
            imgAlt: 'stellenanzeigen.de GmbH',
            imgLink: 'https://www.stellenanzeigen.de/'
        },
        {
            imgSource: 'partner-de/yourfirm.svg',
            imgAlt: 'yourfirm GmbH',
            imgLink: 'https://www.yourfirm.de/'
        }
    ],
    network: [
        {
            imgSource: 'network/adzuna.svg',
            imgAlt: 'Adzuna',
            imgLink: 'https://www.adzuna.at/'
        },
        {
            imgSource: 'network/alleskralle.svg',
            imgAlt: 'alleskralle',
            imgLink: 'https://www.alleskralle.com/'
        },
        {
            imgSource: 'network/indeed.svg',
            imgAlt: 'Indeed',
            imgLink: 'https://at.indeed.com/'
        },
        {
            imgSource: 'network/jobgate.png',
            imgAlt: 'jobgate',
            imgLink: 'https://jobgate.ch/'
        },
        {
            imgSource: 'network/joblift.svg',
            imgAlt: 'Joblift',
            imgLink: 'https://joblift.de/'
        },
        {
            imgSource: 'network/jobrapido.svg',
            imgAlt: 'Jobrapido',
            imgLink: 'https://at.jobrapido.com/'
        },
        {
            imgSource: 'network/jobsat.svg',
            imgAlt: 'jobs.at',
            imgLink: 'https://www.jobs.at/'
        },
        {
            imgSource: 'network/jooble.svg',
            imgAlt: 'Jooble',
            imgLink: 'https://at.jooble.org/'
        },
        {
            imgSource: 'network/newjob.png',
            imgAlt: 'newJOB',
            imgLink: 'https://www.newjob.at/'
        },
        {
            imgSource: 'network/trovit.svg',
            imgAlt: 'Trovit',
            imgLink: 'https://job.trovit.com/'
        },
        {
            imgSource: 'network/ebay-kleinanzeigen.svg',
            imgAlt: 'Ebay Kleinanzeigen',
            imgLink: 'https://ebay.at/'
        },
        {
            imgSource: 'network/jobted.svg',
            imgAlt: 'Jobted',
            imgLink: 'https://jobted.at/'
        },
        {
            imgSource: 'network/jobworld.png',
            imgAlt: 'Jobworld',
            imgLink: 'https://job-world.at/'
        },
        {
            imgSource: 'network/stellenonline.png',
            imgAlt: 'Stellenonline',
            imgLink: 'https://stellenonline.de/'
        },
        {
            imgSource: 'network/talent-com.svg',
            imgAlt: 'neuvoo/talent.com',
            imgLink: 'https://at.talent.com/'
        }
    ],
    payment: [
        {
            imgSource: 'payment/visa.svg',
            imgAlt: 'VISA',
            imgLink: 'https://www.visaeurope.at/'
        },
        {
            imgSource: 'payment/mastercard.svg',
            imgAlt: 'Mastercard',
            imgLink: 'https://www.mastercard.at/'
        },
        {
            imgSource: 'payment/paypal.svg',
            imgAlt: 'PayPal',
            imgLink: 'https://www.paypal.com/at/home'
        },
        {
            imgSource: 'payment/rechnung.svg',
            imgAlt: 'Per Rechnung',
            imgLink: 'https://gocardless.com/de/handbuch/sepa/einfuehrung/'
        }
    ]
};
//# sourceMappingURL=logos-data-de.js.map